export const trainingFormat = {
    1: 'Вебинар',
    // 2: Определить,
    // 3: Определить,
    // 4: Определить,
}
